import {
    SET_RESULT_SEARCH_AFFAIR, SET_FILTERED_AND_SORTED_AFFAIRS, IS_LOADING, SET_ALL_AFFAIRS,
    SET_SELECTED_TYPE, SET_SELECTED_STATE, SET_START_DATE, SET_END_DATE, SET_DISPLAY_ALL_AFFAIRS,
    SET_CURRENT_AFFAIR, NB_MAX_AFFAIRS_TO_DISPLAY, SET_TOTAL_AMOUNT, SET_DISPLAY_AS_LIST
} from './affairConstants'
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { throwErrorMessage } from '../../lib/error_helper';
import { adaptAffairForMyOpen } from './affairCast';
import { setContextInfoOrderBy, setNbTotalResults } from '../contextInfos/contextInfosActions';
import { ALL_SELECT_OPTION } from '../../constants';
import { getSiteIds } from '../customerSite/customerSiteActions';
import { MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS } from '../authorizedApps/authorizedAppsConstants';
import { sortListOfTableBy } from '../../utils';

export function affairsIsLoading(value) {
    return {
        type: IS_LOADING,
        info: 'affairs',
        isLoading: value
    };
}

export function setSelectedTypeAction(selectedType) {
    return {
        type: SET_SELECTED_TYPE,
        selectedType,
    }
}

export function setSelectedStateAction(selectedState) {
    return {
        type: SET_SELECTED_STATE,
        selectedState,
    }
}

export function setStartDateAction(startDate) {
    return {
        type: SET_START_DATE,
        startDate,
    }
}

export function setEndDateAction(endDate) {
    return {
        type: SET_END_DATE,
        endDate,
    }
}

export function setDisplayAllAffairsAction(displayAllAffairs) {
    return {
        type: SET_DISPLAY_ALL_AFFAIRS,
        displayAllAffairs,
    }
}

export function setDisplayAsListAction(displayAsList) {
    return {
        type: SET_DISPLAY_AS_LIST,
        displayAsList,
    }
}

export function setResultSearchAffairAction(resultSearchAffair) {
    return {
        type: SET_RESULT_SEARCH_AFFAIR,
        resultSearchAffair,
    }
}

export function setCurrentAffairAction(currentAffair) {
    return {
        type: SET_CURRENT_AFFAIR,
        currentAffair,
    }
}

export function setFilteredAndSortedAffairsAction(affairs) {
    return {
        type: SET_FILTERED_AND_SORTED_AFFAIRS,
        affairs,
    }
}

export function setAllAffairsAction(allAffairs) {
    return {
        type: SET_ALL_AFFAIRS,
        allAffairs,
    }
}

export function setTotalAmountAction(totalAmount) {
    return {
        type: SET_TOTAL_AMOUNT,
        totalAmount,
    }
}

export function getAffair(code, userId) {
    return (dispatch) => {
        const minLengthOfAffairCode = 4;

        if (code.length < minLengthOfAffairCode)
            return;

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/affair/get_affair/' + userId + "/" + code, {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((affair) => {
                if (affair.affairNotFound)
                    affair = null;

                dispatch(setResultSearchAffairAction(affair));
            }).catch((err) => {
                console.error("Erreur : affairActions - getAffair", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération de l'affaire !",
                }))
            });
    }
}

export function loadAffairs(user, customerSiteId, allSites, affairsFitlers, nbTotalResults) {
    return (dispatch) => {
        let tableState = {
            pageSize: NB_MAX_AFFAIRS_TO_DISPLAY,
            pageNumber: 0,
        }

        dispatch(setFilteredAndSortedAffairs(affairsFitlers, tableState, user, customerSiteId, allSites, nbTotalResults))
    }
}

export function setOrderBy(attribute, desc) {
    return (dispatch) => {
        dispatch(setContextInfoOrderBy(attribute, desc))
    }
}

export function setFilteredAndSortedAffairs(affairsFilters, tableState, user, customerSiteId, allSites, nbTotalResults) {
    return (dispatch) => {
        if (!customerSiteId)
            return;

        dispatch(affairsIsLoading(true));

        let customerSiteIds = getSiteIds(customerSiteId, allSites);

        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/api/v1/affair/get_affairs_of_customer/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                customerSiteIds,
                userId: user.id,
                pageSize: tableState.pageSize,
                pageNumber: tableState.pageNumber,
                selectedState: affairsFilters.selectedState === ALL_SELECT_OPTION ? null : affairsFilters.selectedState,
                selectedType: affairsFilters.selectedType === ALL_SELECT_OPTION ? null : affairsFilters.selectedType,
                startDate: affairsFilters.startDate ? affairsFilters.startDate.utc().format('YYYY-MM-DD HH:mm:ss') : null,
                endDate: affairsFilters.endDate ? affairsFilters.endDate.utc().format('YYYY-MM-DD HH:mm:ss') : null,
                displayAllAffairs: affairsFilters.displayAllAffairs,
            })
        })
            .then((response) => {
                if (!response.ok)
                    throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(result => {
                let allAffairs = [];

                customerSiteIds.forEach(s => {
                    allAffairs = allAffairs.concat(result.affairs[s])
                })

                let transformedAffairs = allAffairs.map(a => adaptAffairForMyOpen(a));
                dispatch(setNbTotalResults(nbTotalResults, MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS, result.nbTotalAffairs));
                transformedAffairs = sortListOfTableBy(tableState.orderBy, tableState.descOrder, transformedAffairs);
                dispatch(setTotalAmountAction(transformedAffairs.map(a => a.planned_sales_amount).reduce((sum, currentValue) => sum + currentValue, 0)))
                dispatch(applyFiltersAndSortAffairs(affairsFilters, transformedAffairs));
            }).catch((err) => {
                console.error("Erreur : affairActions - setFilteredAndSortedAffairs", err);
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des affaires !",
                }))
                dispatch(setNbTotalResults(nbTotalResults, MODULE_EXTRANET_CONTRACTS_AND_AFFAIRS, 0));
                dispatch(setTotalAmountAction(0))
                dispatch(affairsIsLoading(false));
            });
    }
}

function applyFiltersAndSortAffairs(affairsFilters, affairs) {
    return (dispatch) => {
        let filteredAffairs = filter(affairs);
        let sortedAndFilteredAffairs = sort(filteredAffairs);
        dispatch(setFilteredAndSortedAffairsAction(sortedAndFilteredAffairs));
        dispatch(affairsIsLoading(false));
    }
}

export function sort(affairs) {
    return affairs;
}

export function filter(affairs) {
    let filteredAffairs = affairs.filter(() => {
        return true;
    });

    return filteredAffairs;
}

export function setSelectedType(value) {
    return (dispatch) => {
        dispatch(setSelectedTypeAction(value));
    }
}

export function setSelectedState(value) {
    return (dispatch) => {
        dispatch(setSelectedStateAction(value));
    }
}

export function setStartDate(value) {
    return (dispatch) => {
        dispatch(setStartDateAction(value));
    }
}

export function setEndDate(value) {
    return (dispatch) => {
        dispatch(setEndDateAction(value));
    }
}

export function setDisplayAllAffairs(value) {
    return (dispatch) => {
        dispatch(setDisplayAllAffairsAction(value));
    }
}

export function setDisplayAsList(value) {
    return (dispatch) => {
        dispatch(setDisplayAsListAction(value));
    }
}

export function getStates() {
    return ['open', 'close'];
}

export function getTypes() {
    return ['affair', 'contract'];
}

export function loadAffair(affair) {
    return (dispatch) => {
        dispatch(setCurrentAffairAction(affair));
    }
}

export function clearAffair() {
    return (dispatch) => {
        dispatch(loadAffair(null));
    }
}
